const grey10 = "#f9f9f9";
const grey25 = "#f4f4f5";
const grey50 = "#e4e4e5";
const grey75 = "#dddddd";
const grey100 = "#d0d0d1";
const grey200 = "#bfbec0";
const grey300 = "#a1a1a3";
const grey400 = "#848486";
const grey500 = "#4e4e50";
const grey600 = "#454549";
const grey700 = "#353536";
const grey800 = "#1d1d1e";
const grey900 = "#000000";
const greys = {
  grey10,
  grey25,
  grey50,
  grey75,
  grey100,
  grey200,
  grey300,
  grey400,
  grey500,
  grey600,
  grey700,
  grey800,
  grey900
};
export {
  greys as default,
  grey10,
  grey100,
  grey200,
  grey25,
  grey300,
  grey400,
  grey50,
  grey500,
  grey600,
  grey700,
  grey75,
  grey800,
  grey900
};
//# sourceMappingURL=index.es6.js.map
